import { Yup } from 'shared/lib'

const schema = Yup.object().shape({
   cartName: Yup.string().required(),
   email: Yup.string().min(3).max(64).email(),
   cartDescription: Yup.string().nullable(),
})

export default schema
